interface InfoItemProps {
	label: string
	value: string | number
}

export const InfoItem = ({ label, value }: InfoItemProps) => (
	<div className="flex">
		<span className="font-semibold text-gray-700">{label}:</span>
		<span className="ml-2 text-gray-600">{value}</span>
	</div>
)
